<template>
  <v-card>
    <v-toolbar flat :style="backgroundStarStyle">
      <v-row mr-3 ml-4 row>
        <v-col
          cols="10"
          align-self-center
          style="display: flex; flex-direction: row"
        >
          <span class="black--text title mr-3">{{
            getTitle(toolboxName)
          }}</span>
          <exo-help-dialog
            :color="'black--text'"
            :margin="'ma-0'"
            title="TLE ΔV calculator"
            v-if="toolboxName == 'TLEDeltaV'"
          >
            <tooltipTLEDeltaV />
          </exo-help-dialog>
        </v-col>
        <v-col cols="2" align-self-center>
          <v-row style="justify-content: right" class="mr-1">
            <v-icon color="black" @click="$emit('toolboxClosed')">close</v-icon>
          </v-row>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-container>
      <v-row justify-center align-self-center>
        <component :is="toolboxName"></component>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import UnitsConverter from './unitsConverter.vue'
import TLEDecoder from './TLEDecoder.vue'
import TLEDistance from './TLEDistance.vue'
import TLEDeltaV from './TLEDeltaV.vue'
import tooltipTLEDeltaV from '../../components/Tooltips/Toolbox/tooltipTLEDeltaV'
import CustomScenarioSimulation from './CustomScenarioSimulation'
import PropulsionCharacterisation from './PropulsionCharacterisation'

export default {
  name: 'Toolbox',

  components: {
    UnitsConverter,
    TLEDecoder,
    TLEDistance,
    TLEDeltaV,
    tooltipTLEDeltaV,
    CustomScenarioSimulation,
    PropulsionCharacterisation
  },

  props: {
    toolboxName: {
      type: String,
      default: 'UnitsConverter'
    }
  },

  mounted() {},

  data() {
    return {}
  },

  methods: {
    getTitle(toolboxName) {
      switch (toolboxName) {
        case 'UnitsConverter':
          return 'Units Conversion Toolbox'
        case 'TLEDecoder':
          return 'TLE Decoding Toolbox'
        case 'TLEDistance':
          return 'Space objects separation from TLE'
        case 'TLEDeltaV':
          return 'TLE ΔV calculator'
        case 'CustomScenarioSimulation':
          return 'Custom scenario simulation'
        case 'PropulsionCharacterisation':
          return 'Propulsion characterisation'
        default:
          return toolboxName
      }
    }
  },

  computed: {
    backgroundStarStyle() {
      return 'background: #3BE287'
    }
  }
}
</script>
